import { render, staticRenderFns } from "./minimap.vue?vue&type=template&id=f0e84334&scoped=true&lang=pug"
import script from "./minimap.vue?vue&type=script&lang=js"
export * from "./minimap.vue?vue&type=script&lang=js"
import style0 from "./minimap.vue?vue&type=style&index=0&id=f0e84334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e84334",
  null
  
)

export default component.exports